export default __webpack_public_path__ + "static/media/screen3.972578d2.png";